import axios from './api';

const createActualite = async (userData) => {
  const response = await axios.post("/actualites",userData);
  return response.data;
};

const getActualiteById = async (id) => {
  const response = await axios.get("/actualites/" + id);
  return response.data;
};

const getAllActualite= async(params) => {
  try {
    const response = await axios.get("/actualites",{params});
    return response.data;
  } catch (error) {
    throw  error;
  }
};

const DeleteActualite = async (id) => {
  const response = await axios.delete("/actualites/" + id);
  return response.data;
};

const createImage = async (userData) => {
  const response = await axios.post("/actualites/images",userData);
  return response.data;
};

const deleteImage = async (id) => {
  const response = await axios.delete("/actualites/images",{
    params:{id}
  });
  return response.data;
};

const updateActualite = async (id,data) => {
  const response = await axios.patch("/actualites/" + id, data);
  return response.data;
};

const ActualitesService = {
  getAllActualite,
  createActualite,
  getActualiteById,
  DeleteActualite,
  updateActualite,
  deleteImage,
  createImage
};

export default ActualitesService;
